import React from 'react';
import { FadeIn } from './FadeIn';
export function ThisIsForYou() {
  const cards = [{
    title: 'Improvisación constante',
    desc: 'Sentís que cada consulta infantil te obliga a inventar demasiado sobre la marcha.'
  }, {
    title: 'Consulta demasiado teórica',
    desc: 'Sabés qué indicar, pero te cuesta transformarlo en algo aplicable para el niño y la familia.'
  }, {
    title: 'Pocas herramientas visuales',
    desc: 'Necesitás mostrar más y explicar menos, pero no tenés materiales listos.'
  }, {
    title: 'Querés elevar tu consulta',
    desc: 'Buscás una atención más clara, más profesional y con mayor valor percibido.'
  }];
  return <section className="py-10 md:py-14 px-4 bg-black" data-id="element-236">
      <div className="max-w-5xl mx-auto" data-id="element-237">
        <FadeIn className="text-center mb-16" data-id="element-238">
          <span className="text-terracotta text-sm font-bold tracking-widest uppercase mb-4 block" data-id="element-239">
            Esto es para vos
          </span>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-cream mb-6" data-id="element-240">
            ¿Te reconocés?
          </h2>
        </FadeIn>

        <FadeIn delay={0.4} className="text-center" data-id="element-241">
          <div className="inline-block glow-beige-pulse bg-black rounded-2xl py-6 px-10 md:py-8 md:px-14" data-id="element-242">
            <p className="font-display text-2xl md:text-3xl text-cream font-medium italic" data-id="element-243">
              Entonces MegaPack Nutri Infantil Lista fue creado para vos.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}